import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactStars from "react-rating-stars-component";
import styles from "./FeedbackForm.module.css";
import { logoutUser } from './../redux/actions/user';
import { sendFeedback } from './../redux/actions/ticket';

class SendFeedBack extends Component<
    {
        match: any,
        message: any,
        sendFeedback: (id: any, data: any) => void,
        logoutUser: () => void
    },
    {
        feedback: string,
        rating: number
    }
> {
    constructor(props: any) {
        super(props);
        this.state = {
            feedback: "",
            rating: 0,
        };
        this.handleSaveBtnClick = this.handleSaveBtnClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.ratingChanged = this.ratingChanged.bind(this);
    }

    handleInputChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({
            [event.target.name]: event.target.value
        } as any);
    }

    ratingChanged(newRating: number) {
        this.setState({ rating: newRating });
    }

    isCatReady() {
        const { feedback, rating } = this.state;
        return feedback.trim() !== "" && rating > 0;
    }

    handleSaveBtnClick(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        const { feedback, rating } = this.state;
        const id = this.props.match.params.id;
        const data = {
            feedback,
            rating,
            status: 1,
            isActive: 1
        };

        this.props.sendFeedback(id, data);
    }

    render() {
        const { feedback, rating } = this.state;
        const { message } = this.props;
        const isSuccessful = message && /Feedback Send Successfully/i.test(message);        

        let feedbackMessage = '';
        let feedbackSubtext = 'If you have a moment, tell us how it went so we can do better next time.';
;

        if (rating >= 1 && rating <= 2) {
            feedbackMessage = 'Sorry to hear that.';
        } else if (rating > 2 && rating < 4) {
            feedbackMessage = 'Thanks! We got it.';
            feedbackSubtext = 'Thanks! We got it.';
        } else if (rating >= 4 && rating <= 5) {
            feedbackMessage = 'Awesome! We got it.';
        } else {
            feedbackMessage = 'Help us Improve!';
        }

        return (
            <div className={styles.form_container}>
                <div className={styles.card}>
                    <img src="https://demo.simplexts.net/branding.png" alt="Logo" className={styles.logo} />

                    {!message ? (
                        <>
                            <h2>Help us Improve!</h2>

                            <div className={styles.rating}>
                                <ReactStars
                                    count={5}
                                    onChange={this.ratingChanged}
                                    size={40}
                                    value={rating}
                                    activeColor="#3EADD9"
                                />
                            </div>

                            {feedbackSubtext && (
                                <>
                                    <p className={styles.feedbackMessage}>{feedbackMessage}</p>
                                    <p className={styles.feedbackSubtext}>{feedbackSubtext}</p>
                                </>
                            )}

                            <form onSubmit={this.handleSaveBtnClick}>
                                <textarea
                                    id="feedback"
                                    name="feedback"
                                    value={feedback}
                                    onChange={this.handleInputChange}
                                    placeholder="Add your Comment..."
                                    className={styles.textarea}
                                    style={{ fontSize: '14px' }}
                                ></textarea>

                                <button
                                    type="submit"
                                    className={styles.submitButton}
                                    disabled={!this.isCatReady()}
                                >
                                    Submit Now
                                </button>
                            </form>
                        </>
                    ) : (
                        <div className={styles.thankYouMessage}>
                        <h3 style={{ color: isSuccessful ? 'green' : 'red' }}>
                            {isSuccessful ? "Feedback Sent Successfully." : message}
                        </h3>
                        {!isSuccessful && (
                            <p>Thank you for your valuable feedback.</p>
                        )}
                    </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => ({
    message: state.ticket.message
});

const mapDispatchToProps = (dispatch: any) => ({
    sendFeedback: (id: any, data: any) => dispatch(sendFeedback(id, data)),
    logoutUser: () => dispatch(logoutUser())
});

export default connect(mapStateToProps, mapDispatchToProps)(SendFeedBack);
